const REFERRAL_CODE_KEY = 'riise_referral_code';
const REFERRAL_CODE_EXPIRES_AT_KEY = 'riise_referral_code_expires_at';
const CLIENT_REFERRAL_SEPARATOR = '__ref_';
const REFERRAL_TTL_MS = 30 * 24 * 60 * 60 * 1000;

export const normalizeReferralCode = (code) =>
  String(code || '')
    .trim()
    .toUpperCase()
    .replace(/[^A-Z0-9-]/g, '');

export const storeReferralCode = (code) => {
  const normalizedCode = normalizeReferralCode(code);
  if (!normalizedCode) return null;

  localStorage.setItem(REFERRAL_CODE_KEY, normalizedCode);
  localStorage.setItem(REFERRAL_CODE_EXPIRES_AT_KEY, String(Date.now() + REFERRAL_TTL_MS));
  return normalizedCode;
};

export const storeReferralCodeFromUrl = (search = window.location.search) => {
  const params = new URLSearchParams(search);
  return storeReferralCode(params.get('ref'));
};

export const getStoredReferralCode = () => {
  const code = normalizeReferralCode(localStorage.getItem(REFERRAL_CODE_KEY));
  const expiresAt = Number(localStorage.getItem(REFERRAL_CODE_EXPIRES_AT_KEY) || 0);

  if (!code) return '';
  if (expiresAt && expiresAt < Date.now()) {
    localStorage.removeItem(REFERRAL_CODE_KEY);
    localStorage.removeItem(REFERRAL_CODE_EXPIRES_AT_KEY);
    return '';
  }

  return code;
};

export const getCheckoutReferralCode = (fallbackCode = '') =>
  getStoredReferralCode() || normalizeReferralCode(fallbackCode);

export const buildReferralClientReference = (clientReferenceId, referralCode) => {
  const normalizedReferralCode = normalizeReferralCode(referralCode);
  const reference = String(clientReferenceId || '');

  if (!reference || !normalizedReferralCode) return reference;

  return `${reference}${CLIENT_REFERRAL_SEPARATOR}${normalizedReferralCode}`;
};
